export const baseUrl = 'https://student-api.tangosoftware.com/';

let globalVariable = null;

export const setGlobalVariable = (value) => {
  globalVariable = value;
};

export const getGlobalVariable = () => {
  return globalVariable;
};
